import styled from 'styled-components';

export const Wrapper = styled.div`
    display: inline-block;
    width: fit-content;
    height: fit-content;
    align-self: flex-start;
    margin-top: 23px;
`;
